import React from 'react'
import './portfolio.css'
import IMG1 from '../../assests/p2.png'
import IMG2 from '../../assests/p3.png'
import IMG3 from '../../assests/p4.png'
import {AiFillHtml5} from 'react-icons/ai'
import {FaCss3Alt} from 'react-icons/fa'
import {FaBootstrap} from 'react-icons/fa'
import {IoLogoJavascript} from 'react-icons/io'

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Latest Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG1} alt=" "/>
            </div>
            <h3>Tinder For Dog</h3>
            <div className="t-used">
            <AiFillHtml5 />
            <FaCss3Alt />
            <FaBootstrap />
            </div>
            <div className="portfolio__item-cta">
           <a href="https://github.com/prateekarora0819/Tin-Dog" className='btn'>Github</a> 
           <a href="https://www.behance.net/gallery/144977631/Tinder-For-Dog" className='btn btn-primary' target='_blank'>Behance</a>
           </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img src={IMG2} alt=" "/>
            </div>
            <h3>Travelling Website</h3>
            <div className="t-used">
            <AiFillHtml5 />
            <FaCss3Alt />
            <FaBootstrap />
            </div>
           <div className="portfolio__item-cta">
           <a href="https://github.com/prateekarora0819/Travelling_web_page" className='btn'>Github</a> 
           <a href="https://www.behance.net/gallery/144976619/Travelling-Web-Page" className='btn btn-primary' target='_blank'>Behance</a>
           </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio__item-image">
            <img className="simon-img" src={IMG3} alt=" "/>
            </div>
            <h3>Simon Game</h3>
            <div className="t-used">
            <AiFillHtml5 />
            <FaCss3Alt />
            <IoLogoJavascript />
            </div>
            <div className="portfolio__item-cta">
           <a href="https://github.com/prateekarora0819/SimonGame" className='btn'>Github</a> 
           <a href="https://www.behance.net/gallery/144978151/Simon-Game" className='btn btn-primary' target='_blank'>Behance</a>
           </div>
        </article>
      </div>
    </section>
  )
}

export default Portfolio